// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".courses[data-v-2154ac4d],\n.tracks[data-v-2154ac4d] {\n  max-height: 200px;\n  margin: 10px 0;\n  overflow: auto;\n}\n", ""]);
// Exports
module.exports = exports;
